import { trpc } from "@mnk/frontend/lib/trpc";
import { Link } from "react-router-dom";

export const SideMenu = () => {
  const getUser = trpc.getUser.useQuery();
  const user = getUser.data;

  return (
    <div className="w-64 h-full">
      <div className="flex items-center pb-4">
        <p className="text-sm font-bold">設定</p>
      </div>
      <div className="flex flex-col gap-4 text-sm">
        <Link to="/settings/account">アカウント設定</Link>
        <Link to="/settings/password-reset">パスワード変更</Link>
        {user?.role === "admin" && <Link to="/settings/users">ユーザー管理</Link>}
        <Link to="/settings/logout">ログアウト</Link>
      </div>
    </div>
  );
};
